import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { FusePageSimple } from '@fuse';
import { bindActionCreators } from 'redux';
// import classNames from 'classnames';
// import Products from './components/Products';

import { Button, FormControlLabel, MenuItem, Radio, Typography, Checkbox, Toolbar, AppBar } from 'material-ui';
import { TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';
import TextField from 'material-ui/TextField';
import Formsy from 'formsy-react';
import classNames from 'classnames';
import $ from "jquery";
import { withAlert } from 'react-alert';
// import PropTypes from 'prop-types';
import FileUpload from '@material-ui/icons/FileUpload';
import Icon from 'material-ui/Icon';
import IconButton from 'material-ui/IconButton';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import DeleteIcon from '@material-ui/icons/Delete';
import Input, { InputLabel, InputAdornment } from 'material-ui/Input';
import AddIcon from '@material-ui/icons/Add';
import ReactDOM from 'react-dom';
import BrokerAddDailog from './brokerAddDailog'

import CloseIcon from '@material-ui/icons/Close';
import axios from 'axios';
import Loader from "other-components/loader/loader";

import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from 'material-ui/Dialog';
import ReactTable from "react-table";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const styles = theme => ({
    layoutRoot: {},
    // layoutToolbar: {
    //     padding: 0
    // },
    // tabsRoot: {
    //     height: 64
    // },
    // tabRoot: {
    //     height: 64
    // },
    // root: {
    //     width: '100%',
    // },
    // heading: {
    //     fontSize: theme.typography.pxToRem(15),
    //     flexBasis: '33.33%',
    //     flexShrink: 0,
    // },
    // secondaryHeading: {
    //     fontSize: theme.typography.pxToRem(15),
    //     color: theme.palette.text.secondary,
    // }
});


var id = null;
var broker_code = null;
var broker_ref_number = null;
var broker_name = null;
var broker_title = null;
var broker_nic = null;
var address = null;
var address2 = null;
var state = null;
var city = null;
var zipcode = null;
var countrycode = null;
var email = null;
var mobile = null
var telephone = null;
var fax = null;
var is_active = null;
var is_suspend = null;
var last_deal_date = null;
var no_of_deals = null;
var is_active_value = null;
var is_suspend_value = null;

class Broker extends Component {

    state = {
        value: 0
    };

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            loadTitleTypes: [],
            isSuspend: false,
            openComposeDialog: false,
            loading: true,
            isActive: true,
            isSuspends: false,
            isActives: false,
            isTableAdd: false,
            brokerObj: null,
            noOfDeals: '',
            lastDealdate: '',
            value: ''
        };
        // alert(this.props.ref_no)
        this.loadData();
        this.loadEmployeeTitleTypes();
        this.openNewCustomerDialog = this.openNewCustomerDialog.bind(this);
        this.closeNewCustomerDialog = this.closeNewCustomerDialog.bind(this);
    }

    openNewCustomerDialog() {
        // this.setState({ loading: true });
        // this.setState({ expanded: 'panel1' });
        // this.clearContactPersons;
        this.setState({ openComposeDialog: true });
        // this.setState({ loading: false });
    }

    closeNewCustomerDialog() {
        this.setState({ openComposeDialog: false });
    }

    handleChange = panel => (event, expanded) => {
        this.setState({
            expanded: expanded ? panel : false,
        });
    };

    handleCloseEdit = () => {
        this.setState({ edit: false });
    };

    clearValue = () => {
        this.form.reset();
    }

    handleCloseDelete = () => {
        this.setState({ delete: false });
    };

    onDelete = (model) => {
        // this.deleteBrokerDetail(model);
    };

    onEdit = (model) => {
        this.editBrokerDetail(model);
    };

    // edit employee profesional qulification details
    editBrokerDetail(model) {
        // alert(model.id)
        var brokerId = model.id;

        if (null == brokerId || "" == brokerId || undefined == brokerId) {
            // alert("Cannot Delete this Employee");
        } else {
            // var broker_code = model.broker_code,
            // var broker_ref_no = model.broker_ref_number,            
            // var title = model.broker_title,
            // var nic = model.broker_nic,
            var name = model.broker_name;
            var address = model.address;
            var address2 = model.address2;
            var state = model.state;
            var city = model.city;
            var zipcode = model.zipcode;
            var countrycode = model.countrycode;
            var email = model.email;
            var mobile = model.mobile;
            var telephone = model.telephone;
            var fax = model.fax;

            if (name == null) {
                name = '';
            }
            if (address == null) {
                address = '';
            }
            if (address2 == null) {
                address2 = '';
            }
            if (state == null) {
                state = '';
            }
            if (city == null) {
                city = '';
            }
            if (zipcode == null) {
                zipcode = '';
            }
            if (countrycode == null) {
                countrycode = '';
            }
            if (email == null) {
                email = '';
            }
            if (mobile == null) {
                mobile = '';
            }
            if (telephone == null) {
                telephone = '';
            }
            if (fax == null) {
                fax = '';
            }

            var editObj = {
                id: model.id,
                broker_code: model.broker_code,
                broker_ref_no: model.broker_ref_number,
                name: name,
                title: model.broker_title,
                nic: model.broker_nic,
                address: address,
                address_line2: address2,
                state: state,
                city: city,
                zipcode: zipcode,
                countrycode: countrycode,
                email: email,
                mobile: mobile,
                telephone: telephone,
                fax: fax,
                is_active: this.state.isActives,
                is_suspend: this.state.isSuspends
            }

            // axios.post('http://localhost:5006/broker/deActiveBroker', editObj)
            //     // axios.post(window.salesServer+'/broker/deActiveBroker', editObj)
            //     .then(response => {

            //         if (response.data.success) {

            // axios.post('http://localhost:5006/broker/updateBroker', editObj)
            axios.post(window.salesServer + '/broker/updateBroker', editObj)
                .then(res => {

                    if (res.data.success) {
                        // alert("Success");
                        this.props.alert.success("Broker Details Updated Successfully.");
                        this.handleCloseEdit();
                        this.loadData();
                    } else {
                        // alert('Ivalid Credentials');
                        this.props.alert.error("Error In Broker Details Update.");
                    }
                    //         })
                    // } else {
                    //     // alert("Delete Faild !");
                    // }
                }).catch(function (error) {
                    // alert("Error");
                    console.log("No internet connection or Internal error");
                    // alert("No internet connection or Internal error");
                });

        }
    }


    // delete employee profesional qulification details
    deleteBrokerDetail(model) {
        // alert(model.id)
        var brokerId = model.id;

        if (null == brokerId || "" == brokerId || undefined == brokerId) {
            alert("Cannot Delete this Employee");
        } else {

            var deleteObj = {
                id: brokerId
            }
            // axios.post('http://localhost:5006/broker/deActiveBroker', deleteObj)
            axios.post(window.salesServer + '/broker/deActiveBroker', deleteObj)
                .then(response => {

                    if (response.data.success) {
                        // alert('Success');
                        this.props.alert.success("Employee Broker Deleted Successfully.");
                        this.handleCloseDelete();
                        this.loadData();
                    } else {
                        // alert("Delete Faild !");
                        this.props.alert.error("Error In Broker Deleting.");
                    }
                }).catch(function (error) {
                    // alert("Error");
                    console.log("No internet connection or Internal error");
                    // alert("No internet connection or Internal error");
                });
        }
    }

    handleCheckSuspendChange = name => event => {
        this.setState({ [name]: event.target.checked });
    };

    handleCheckActiveChange = name => event => {
        this.setState({ [name]: event.target.checked });
    };

    handleCheckSuspendChanges = name => event => {
        this.setState({ [name]: event.target.checked });
    };

    handleCheckActiveChanges = name => event => {
        this.setState({ [name]: event.target.checked });
    };


    // load employee gender into drop-down
    loadEmployeeTitleTypes() {
        var loadTitleTypes = [];

        axios.get(window.systemServer + '/system/loadTitle')
            .then(response => {
                if (window.DATABASE_TYPE == "MYSQL")
                    for (let i = 0; i < response.data.result.length; i++) {
                        loadTitleTypes.push({
                            value: response.data.result[i].title
                        });
                    }
                else
                    for (let i = 0; i < response.data.length; i++) {
                        loadTitleTypes.push({
                            value: response.data[i].title
                        });
                    }
                this.setState({ loadTitleTypes: loadTitleTypes });

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }

    loadData() {
        var resObj;

        var brokerObjArray = []
        var length;
        var lastDate;
        // axios.get('http://localhost:5006/broker/getBrokersList')
        axios.get(window.salesServer + '/broker/getBrokersList')
            .then(response => {
                if (response.data.success) {
                    this.setState({ brokerObj: response.data.brokers });
                    resObj = response.data.invoices;

                    for (var i = 0; i < this.state.brokerObj.length; i++) {

                        var allDataObj = {};
                        allDataObj.id = this.state.brokerObj[i].ID_SALES_BROKER,
                            allDataObj.broker_code = this.state.brokerObj[i].CODE,
                            allDataObj.broker_name = this.state.brokerObj[i].NAME,
                            allDataObj.broker_ref_number = this.state.brokerObj[i].REFERENCE_NUMBER,
                            allDataObj.broker_title = this.state.brokerObj[i].TITLE,
                            allDataObj.broker_nic = this.state.brokerObj[i].NIC,
                            allDataObj.address = this.state.brokerObj[i].ADDRESS,
                            allDataObj.address2 = this.state.brokerObj[i].ADDRESS_LINE_2,
                            allDataObj.state = this.state.brokerObj[i].STATE,
                            allDataObj.city = this.state.brokerObj[i].CITY,
                            allDataObj.zipcode = this.state.brokerObj[i].ZIP_CODE,
                            allDataObj.countrycode = this.state.brokerObj[i].COUNTRY_CODE,
                            allDataObj.email = this.state.brokerObj[i].EMAIL,
                            allDataObj.mobile = this.state.brokerObj[i].MOBILE,
                            allDataObj.telephone = this.state.brokerObj[i].TELEPHONE,
                            allDataObj.fax = this.state.brokerObj[i].FAX,
                            allDataObj.is_active = this.state.brokerObj[i].IS_ACTIVE,
                            allDataObj.is_suspend = this.state.brokerObj[i].isSuspended
                        if (this.state.brokerObj[i].IS_ACTIVE == 1) {
                            allDataObj.is_active_value = 'Active'
                        } else {
                            allDataObj.is_active_value = 'Inactive'
                        }
                        if (this.state.brokerObj[i].isSuspended == 1) {
                            allDataObj.is_suspend_value = 'Suspended'
                        } else {
                            allDataObj.is_suspend_value = 'info'
                        }

                        const countTypes = resObj.filter(movie => movie.ID_SALES_BROKER === this.state.brokerObj[i].ID_SALES_BROKER);
                        console.log("fdfdf " + JSON.stringify(countTypes));
                        if (countTypes.length == 0) {
                            allDataObj.last_deal_date = "";
                        } else {
                            var end_date = new Date(countTypes[0].CREATED_DATE)
                            var expected_date = end_date.getFullYear() + '-' + end_date.getMonth() + '-' + end_date.getDate();
                            allDataObj.last_deal_date = expected_date;
                        }
                        // allDataObj.last_deal_date = "",
                        allDataObj.no_of_deals = countTypes.length
                        brokerObjArray.push(allDataObj)
                    }

                    this.appendToTable(brokerObjArray)

                } else {
                    // alert("else")
                    var data = [];
                    this.setState({ data: data });
                    this.setState({ loading: false });
                }


            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });

        this.handleCloseEdit();
    }



    getInvoiceData(value) {
        const searchValueObj = {
            searchval: value
        }
        // axios.post('http://localhost:5006/invoice/searchInvoicesListByBrokerId', searchValueObj)
        axios.post(window.salesServer + '/invoice/searchInvoicesListByBrokerId', searchValueObj)
            .then(response => {
                if (response.data.success) {

                }
            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
            });
    }

    appendToTable(brokerObj) {

        console.log(brokerObj)
        var data = [];

        for (var i = 0; i < brokerObj.length; i++) {

            data.push({
                id: brokerObj[i].id,
                broker_code: "B-" + brokerObj[i].id,
                broker_name: brokerObj[i].broker_name,
                broker_ref_number: brokerObj[i].broker_ref_number,
                broker_title: brokerObj[i].broker_title,
                broker_nic: brokerObj[i].broker_nic,
                address: brokerObj[i].address,
                address2: brokerObj[i].address2,
                state: brokerObj[i].state,
                city: brokerObj[i].city,
                zipcode: brokerObj[i].zipcode,
                countrycode: brokerObj[i].countrycode,
                email: brokerObj[i].email,
                mobile: brokerObj[i].mobile,
                telephone: brokerObj[i].telephone,
                fax: brokerObj[i].fax,
                is_active: brokerObj[i].is_active,
                is_suspend: brokerObj[i].is_suspend,
                last_deal_date: brokerObj[i].last_deal_date,
                no_of_deals: brokerObj[i].no_of_deals,
                is_active_value: brokerObj[i].is_active_value,
                is_suspend_value: brokerObj[i].is_suspend_value
            });

        }

        this.setState({ data: data });
        this.setState({ loading: false });
    }


    loadSearchData(searchValue) {

        const searchValueObj = {
            searchval: searchValue
        }
        var data = [];

        // axios.post('http://localhost:5002/hr/searchEmpProfesionalQulification', searchValueObj)
        axios.post(window.hrmServer + '/hr/searchEmpProfesionalQulification', searchValueObj)
            .then(response => {
                if (response.data.success) {
                    // alert('Success');
                    var brokerObj = response.data.rows;

                    for (var i = 0; i < brokerObj.length; i++) {

                        data.push({
                            broker_code: "B-" + brokerObj[i].ID_SALES_BROKER,
                            broker_name: brokerObj[i].NAME,
                            broker_ref_number: brokerObj[i].REFERENCE_NUMBER,
                            broker_title: brokerObj[i].TITLE,
                            broker_nic: brokerObj[i].NIC,
                            address: brokerObj[i].ADDRESS,
                            address2: brokerObj[i].ADDRESS_LINE_2,
                            state: brokerObj[i].STATE,
                            city: brokerObj[i].CITY,
                            zipcode: brokerObj[i].ZIP_CODE,
                            countrycode: brokerObj[i].COUNTRY_CODE,
                            email: brokerObj[i].EMAIL,
                            mobile: brokerObj[i].MOBILE,
                            telephone: brokerObj[i].TELEPHONE,
                            fax: brokerObj[i].FAX,



                        });
                    }
                }
                this.setState({ data: data });

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });

        this.handleCloseEdit();
    }

    onSubmit = (model) => {

        // if ("" == this.state.emp_profile_id || null == this.state.emp_profile_id || undefined == this.state.emp_profile_id ||
        //     "" == this.state.emp_registry_id || null == this.state.emp_registry_id || undefined == this.state.emp_registry_id) {
        //     this.props.alert.error("Unable to Saved Please Check !");
        // } else {
        this.saveBroker(model);

        // }

    };

    handleSearchAny = (e) => {
        // alert(e.target.value)
        this.setState({
            value: e.target.value
        });
        this.loadSearchData(e.target.value)
    }



    saveBroker(model) {

        const brokerObj = {
            broker_code: model.broker_code,
            broker_ref_no: model.broker_ref_number,
            name: model.broker_name,
            title: model.broker_title,
            nic: model.broker_nic,
            address: model.address,
            address_line2: model.address2,
            state: model.state,
            city: model.city,
            zipcode: model.zipcode,
            countrycode: model.countrycode,
            email: model.email,
            mobile: model.mobile,
            telephone: model.telephone,
            fax: model.fax,
            is_active: this.state.isActive,
            is_suspend: this.state.isSuspend
        }



        // axios.post('http://localhost:5006/broker/saveBroker', brokerObj)
        axios.post(window.salesServer + '/broker/saveBroker', brokerObj)
            .then(res => {

                if (res.data.success) {
                    // alert("Success");
                    this.props.alert.success("Broker Details Update Successfully.");

                    this.setState({
                        isActives: false,
                        isSuspends: false
                    });

                    this.loadData();
                    this.form.reset();
                    this.setState({ openComposeDialog: false });
                } else {
                    // alert(res.data.message);
                    this.props.alert.error(res.data.message);
                }
            })


    }

    render() {

        const { classes, setSearchText, searchText } = this.props;
        const { value } = this.state;
        if (this.state.loading) {
            return (<Loader />);
        }
        else {
            return (
                <React.Fragment>
                    <div>
                        <Toolbar className="flex w-full pt-24 px-12 ml-1920">
                            <h2 className="subtitle-color subtitle-margin w-full">
                                Broker
                            </h2>
                            <div className="px-12">
                                <Button
                                    className="w-160"
                                    type="button"
                                    variant="raised"
                                    color="secondary"
                                    onClick={(ev) => {
                                        // ev.stopPropagation();
                                        // this.removeContactPerson();
                                        this.openNewCustomerDialog();
                                        // this.check();
                                    }}
                                >
                                    Add New Broker
                                </Button>
                            </div>
                            <div className="px-12">
                                <Button
                                    variant="raised"
                                    color="default"
                                >
                                    Help
                                </Button>
                            </div>
                        </Toolbar>
                        {/* ReactDOM.render(<BrokerAddDailog />, document.getElementById('root')); */}

                        {/* <BrokerAddDailog /> */}
                        <Dialog className={classNames(classes.root, "z-10")} open={this.state.openComposeDialog} fullWidth maxWidth="md">
                            <AppBar className="flex w-full h-50 app-bar-size" position="static">
                                <Toolbar className="flex w-full">
                                    <Typography className="w-full" variant="subheading" color="inherit">
                                        New Broker
                                    </Typography>
                                    <IconButton className="" color="inherit" onClick={this.closeNewCustomerDialog} aria-label="Close">
                                        <CloseIcon />
                                    </IconButton>
                                </Toolbar>
                            </AppBar>
                            <Formsy
                                onValidSubmit={this.onSubmit}
                                onValid={this.enableButton}
                                onInvalid={this.disableButton}
                                ref={(form) => this.form = form}
                                className="flex flex-col justify-center"
                            >

                                <div className="flex flex-wrap -mx-3 mb-6">
                                    <div className="w-full p-16 mt-4 pr-24 border-solid border-1 rounded border-grey bg-grey-lightest">
                                        {/* <TextFieldFormsy
                                            className="w-full md:w-1/6 pr-16 pr-24"
                                            type="text"
                                            name="broker_code"
                                            label="Broker Code"
                                            validations={{
                                                maxLength: 50
                                            }}
                                            validationErrors={{

                                                maxLength: 'This is not a valid'
                                            }}

                                        /> */}
                                        <TextFieldFormsy
                                            className="w-full md:w-1/6 pr-24"
                                            type="text"
                                            name="broker_ref_number"
                                            label="Broker Ref No"
                                            validations={{
                                                maxLength: 50
                                            }}
                                            validationErrors={{

                                                maxLength: 'This is not a valid'
                                            }}

                                        />

                                        <SelectFormsy
                                            className="w-full md:w-1/6 pr-24"
                                            name="broker_title"
                                            label="       "
                                            value="Mr"
                                        >
                                            <MenuItem className="popup-value-size" disabled value="none" ref="employeeData">
                                                <em>Broker Title</em>

                                            </MenuItem>
                                            {this.state.loadTitleTypes.map(function (item, i) {
                                                return <MenuItem className="popup-value-size" value={item.value}>{item.value}</MenuItem>;
                                            })}

                                        </SelectFormsy>

                                        <TextFieldFormsy
                                            className="w-full md:w-1/2 pr-24"
                                            type="text"
                                            name="broker_name"
                                            label="Broker Name"
                                            required
                                            validations={{
                                                maxLength: 150
                                            }}
                                            validationErrors={{

                                                maxLength: 'This is not a valid'
                                            }}

                                        />
                                        <TextFieldFormsy
                                            className="w-full md:w-1/3 pr-24"
                                            type="text"
                                            name="broker_nic"
                                            label="NIC/SSN/Passport"
                                            validations={{
                                                maxLength: 50
                                            }}
                                            validationErrors={{

                                                maxLength: 'This is not a valid'
                                            }}

                                        />
                                    </div>
                                    <div className="w-full p-16 mt-8 pr-24 border-solid border-1 rounded border-grey bg-grey-lightest">
                                        <div >
                                            <h3 className="mt-16">Contact Details</h3>
                                        </div>

                                        <TextFieldFormsy
                                            className="w-full md:w-1/3 pr-24"
                                            type="text"
                                            name="address"
                                            label="Address"
                                            required
                                            validations={{
                                                maxLength: 150
                                            }}
                                            validationErrors={{

                                                maxLength: 'This is not a valid'
                                            }}
                                        />
                                        <TextFieldFormsy
                                            className="w-full md:w-1/3 pr-16 pr-24"
                                            type="text"
                                            name="address2"
                                            label="Address Line 2"
                                            validations={{
                                                maxLength: 150
                                            }}
                                            validationErrors={{

                                                maxLength: 'This is not a valid'
                                            }}

                                        />
                                        <TextFieldFormsy
                                            className="w-full md:w-1/3 pr-24"
                                            type="email"
                                            name="email"
                                            label="Email"
                                            validations="isEmail"
                                            validationError="This is not a valid email"
                                        />

                                        <TextFieldFormsy
                                            className="w-full md:w-1/4 pr-24"
                                            type="text"
                                            name="state"
                                            label="State"
                                            validations={{
                                                maxLength: 50
                                            }}
                                            validationErrors={{

                                                maxLength: 'This is not a valid'
                                            }}



                                        />

                                        <TextFieldFormsy
                                            className="w-full md:w-1/4 pr-24"
                                            type="text"
                                            name="city"
                                            label="City"
                                            validations={{
                                                maxLength: 50
                                            }}
                                            validationErrors={{

                                                maxLength: 'This is not a valid'
                                            }}

                                        />

                                        <TextFieldFormsy
                                            className="w-full md:w-1/4 pr-24"
                                            type="text"
                                            name="zipcode"
                                            label="Zip Code"
                                            validations={{
                                                maxLength: 50
                                            }}
                                            validationErrors={{

                                                maxLength: 'This is not a valid'
                                            }}

                                        />

                                        <TextFieldFormsy
                                            className="w-full md:w-1/4 pr-24"
                                            label="Country Code"
                                            name="countrycode"
                                            type="text"
                                            validations={{
                                                maxLength: 50
                                            }}
                                            validationErrors={{

                                                maxLength: 'This is not a valid'
                                            }}
                                        />

                                        <TextFieldFormsy
                                            className="w-full md:w-1/3 pr-24"

                                            label="Mobile"
                                            name="mobile"
                                            type="number"
                                            required
                                            validations={{
                                                maxLength: 20
                                            }}
                                            validationErrors={{

                                                maxLength: 'This is not a valid'
                                            }}
                                        />

                                        <TextFieldFormsy
                                            className="w-full md:w-1/3 pr-24"
                                            type="number"
                                            name="telephone"
                                            label="Telephone"
                                            validations={{
                                                maxLength: 20
                                            }}
                                            validationErrors={{

                                                maxLength: 'This is not a valid'
                                            }}

                                        />
                                        <TextFieldFormsy
                                            className="w-full md:w-1/3 pr-24"
                                            type="number"
                                            name="fax"
                                            label="Fax"
                                            validations={{
                                                maxLength: 20
                                            }}
                                            validationErrors={{

                                                maxLength: 'This is not a valid'
                                            }}

                                        />


                                        <div className="w-full md:w-1/4 pr-24">
                                            <FormControlLabel
                                                className=" "
                                                control={
                                                    <Checkbox
                                                        checked={this.state.isSuspend}
                                                        onChange={this.handleCheckSuspendChange('isSuspend')}
                                                        color="primary"
                                                        disabled
                                                    />
                                                }
                                                label="Suspend"
                                            />
                                            <FormControlLabel
                                                className=" "
                                                control={
                                                    <Checkbox
                                                        checked={this.state.isActive}
                                                        onChange={this.handleCheckActiveChange('isActive')}
                                                        color="primary"
                                                        disabled
                                                    />
                                                }
                                                label="Active"
                                            />
                                        </div>

                                    </div>

                                    <div className="w-full md:w-2/3">

                                    </div>

                                    <DialogActions className=" justify-right pl-16  ">

                                        <Button type="submit" variant="raised" size="small" color="secondary" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 mr-8">
                                            Save
                                        </Button>

                                        <Button type="button" variant="raised" size="small" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 mr-8" onClick={this.clearValue}>
                                            Clear
                                        </Button>
                                        <Button type="button" variant="raised" size="small" color="primary" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16" onClick={this.closeNewCustomerDialog}>
                                            Close
                                        </Button>
                                    </DialogActions>
                                </div>
                            </Formsy>

                        </Dialog>

                        <div className="p-20">
                            <div>
                                <div className="flex flex-wrap -mx-3 mb-12">
                                    <div className="w-full md:w-2/3"></div>
                                    {/* <div className="w-full md:w-1/3">
                                
                                <TextField
                                    placeholder="Search for anything"
                                    className="pl-16"
                                    fullWidth
                                    value={this.state.value}
                                    inputProps={{
                                        'aria-label': 'Search'
                                    }}
                                    onChange={this.handleSearchAny}
                                />
                                {/* <Icon className="-mb-4 -mr-4" color="action">search</Icon> */}
                                    {/* </div> */}
                                </div>


                                <div class="flex h-auto">

                                    <div class="w-full bg-white h-auto">
                                        <ReactTable
                                            getTrProps={(state, rowInfo, column) => {
                                                return {
                                                    className: "cursor-pointer",
                                                    onClick: (e, handleOriginal) => {

                                                    }
                                                }
                                            }}
                                            data={this.state.data}
                                            columns={[
                                                {
                                                    Header: "Broker Code",
                                                    className: "justify-start",
                                                    accessor: "broker_code"

                                                },
                                                {
                                                    Header: "Broker Ref No",
                                                    className: "justify-start",
                                                    accessor: "broker_ref_number"

                                                },
                                                {
                                                    Header: "Broker Name",
                                                    className: "justify-start",
                                                    accessor: "broker_name"

                                                },
                                                {
                                                    Header: "Mobile",
                                                    className: "justify-start",
                                                    accessor: "mobile"

                                                },
                                                {
                                                    Header: "Last Deal Date",
                                                    className: "justify-start",
                                                    accessor: "last_deal_date"

                                                },
                                                {
                                                    Header: "No Of Deals",
                                                    className: "justify-start",
                                                    accessor: "no_of_deals"

                                                },
                                                {
                                                    Header: "Total Commision",
                                                    className: "justify-start",
                                                    accessor: "total_commision"

                                                },
                                                {
                                                    Header: "Status",
                                                    accessor: "status",
                                                    className: "justify-center",
                                                    Cell: row => (

                                                        <div className="flex items-center">
                                                            <Icon
                                                                className={row.original.is_active_value === 'Active' ? 'text-green-light'
                                                                    : row.original.is_active_value === 'Inactive' ? 'text-red-light'
                                                                        : 'text-orange-light'}
                                                                title={row.original.is_active_value === 'Active' ? 'Active'
                                                                    : row.original.is_active_value === 'Inactive' ? 'Inactive'
                                                                        : 'text-orange-light'}
                                                            >
                                                                {row.original.is_active_value === 'Active' ? 'check_circle'
                                                                    : row.original.is_active_value === 'Inactive' ? `cancel`
                                                                        : 'Other'}
                                                            </Icon>
                                                            <Icon
                                                                className='text-orange-light'
                                                                title={row.original.is_suspend_value ? 'Suspended'
                                                                    : ''}
                                                            >
                                                                {row.original.is_suspend_value === 'Suspended' ? 'info'
                                                                    : ''}
                                                            </Icon>

                                                        </div>
                                                    )

                                                },
                                                {
                                                    Header: "Action",
                                                    // accessor: "su",
                                                    width: 128,
                                                    className: "justify-center",
                                                    Cell: row => (
                                                        <div className="flex items-center w-8 h-8">
                                                            <IconButton

                                                                onClick={(e) => {
                                                                    if (row) {
                                                                        broker_code = row.original.broker_code;
                                                                        id = row.original.id;
                                                                        broker_ref_number = row.original.broker_ref_number;
                                                                        broker_name = row.original.broker_name;
                                                                        broker_nic = row.original.broker_nic;
                                                                        address = row.original.address;
                                                                        address2 = row.original.address2;
                                                                        state = row.original.state;
                                                                        city = row.original.city;
                                                                        zipcode = row.original.zipcode;
                                                                        countrycode = row.original.countrycode;
                                                                        email = row.original.email;
                                                                        telephone = row.original.telephone;
                                                                        mobile = row.original.mobile;
                                                                        fax = row.original.fax;
                                                                        is_active = row.original.is_active;
                                                                        is_suspend = row.original.is_suspend;
                                                                        this.setState({ isSuspends: row.original.is_suspend });
                                                                        this.setState({ isActives: row.original.is_active });
                                                                        // responsibilities = row.original.responsibilities;
                                                                        // emp_profile_id = row.original.emp_profile_id;
                                                                        // emp_registry_id = row.original.emp_registry_id;
                                                                        this.setState({ edit: true });
                                                                    }
                                                                }}

                                                            >
                                                                <Icon className="text-blue">mode_edit</Icon>
                                                            </IconButton>

                                                            {/* /////me */}
                                                            <Dialog

                                                                open={this.state.edit}
                                                                onClose={this.handleCloseEdit}
                                                                aria-labelledby="form-dialog-title"
                                                            >
                                                                <Formsy
                                                                    onValidSubmit={this.onEdit}
                                                                    onValid={this.enableButtonEdit}
                                                                    onInvalid={this.disableButtonEdit}
                                                                    ref={(form) => this.form = form}
                                                                    className=""
                                                                >


                                                                    <AppBar className="flex w-full h-50 app-bar-size" position="static">
                                                                        <Toolbar className="flex w-full">
                                                                            <Typography className="w-full" variant="subheading" color="inherit">
                                                                                Edit Broker Details
                                                                            </Typography>
                                                                            <IconButton className="" color="inherit" onClick={this.handleCloseEdit} aria-label="Close">
                                                                                <CloseIcon />
                                                                            </IconButton>
                                                                        </Toolbar>
                                                                    </AppBar>
                                                                    <DialogContent className="flex flex-wrap broker-popup-margin">

                                                                        <div className="w-full">

                                                                            <TextFieldFormsy
                                                                                type="hidden"
                                                                                name="id"
                                                                                value={id}
                                                                            />
                                                                            <TextFieldFormsy
                                                                                type="hidden"
                                                                                name="emp_profile_id"
                                                                            // value={emp_profile_id}
                                                                            />
                                                                            <TextFieldFormsy
                                                                                type="hidden"
                                                                                name="emp_registry_id"
                                                                            // value={emp_registry_id}
                                                                            />

                                                                            <TextFieldFormsy
                                                                                className="w-1/2 pr-8"
                                                                                type="text"
                                                                                name="broker_nic"
                                                                                label="NIC No"
                                                                                value={broker_nic}
                                                                                required
                                                                                disabled={true}
                                                                            />

                                                                            <TextFieldFormsy
                                                                                className="w-1/2 pr-8"
                                                                                type="text"
                                                                                name="broker_code"
                                                                                label="Broker Code"
                                                                                disabled={true}
                                                                                value={broker_code}

                                                                            />


                                                                        </div>
                                                                        <div className="w-full">
                                                                            <TextFieldFormsy
                                                                                className="w-1/2 mt-16"
                                                                                type="text"
                                                                                name="broker_ref_number"
                                                                                label="Broker Ref No"
                                                                                disabled={true}
                                                                                value={broker_ref_number}

                                                                            />

                                                                            <TextFieldFormsy
                                                                                className="w-1/2 mt-16"
                                                                                type="text"
                                                                                name="broker_name"
                                                                                label="Broker Name"
                                                                                value={broker_name}

                                                                            />
                                                                        </div>

                                                                        <div className="w-full">
                                                                            <TextFieldFormsy
                                                                                className="w-full mt-16"
                                                                                type="text"
                                                                                name="address"
                                                                                label="Address"
                                                                                value={address}
                                                                            // required
                                                                            // disabled={true}
                                                                            />
                                                                        </div>
                                                                        <div className="w-full">
                                                                            <TextFieldFormsy
                                                                                className="w-full mt-16"
                                                                                type="text"
                                                                                name="address2"
                                                                                label="Address 2"
                                                                                value={address2}
                                                                            // required
                                                                            // disabled={true}
                                                                            />
                                                                        </div>

                                                                        <div className="w-full">
                                                                            <TextFieldFormsy
                                                                                className="w-1/2 pr-8 mt-16"
                                                                                type="text"
                                                                                name="state"
                                                                                label="State"
                                                                                value={state}
                                                                            // required
                                                                            // disabled={true}
                                                                            />
                                                                            <TextFieldFormsy
                                                                                className="w-1/2 mt-16"
                                                                                type="text"
                                                                                name="city"
                                                                                label="City"
                                                                                value={city}
                                                                            />
                                                                        </div>

                                                                        <div className="w-full">
                                                                            <TextFieldFormsy
                                                                                className="w-1/2 pr-8 mt-16"
                                                                                type="text"
                                                                                name="zipcode"
                                                                                label="Zip Code"
                                                                                value={zipcode}
                                                                            // required
                                                                            // disabled={true}
                                                                            />

                                                                            <TextFieldFormsy
                                                                                className="w-1/2 mt-16"
                                                                                type="text"
                                                                                name="countrycode"
                                                                                label="Country Code"
                                                                                value={countrycode}
                                                                            // validations="isEmail"
                                                                            // validationError="This is not a valid email"
                                                                            />
                                                                        </div>

                                                                        <div className="w-full">
                                                                            <TextFieldFormsy
                                                                                className="w-1/2 pr-8 mt-16"
                                                                                type="text"
                                                                                name="telephone"
                                                                                label="Telephone"
                                                                                value={telephone}
                                                                            // disabled={true}
                                                                            />

                                                                            <TextFieldFormsy
                                                                                className="w-1/2 mt-16"
                                                                                type="text"
                                                                                name="mobile"
                                                                                label="Mobile"
                                                                                value={mobile}
                                                                            // disabled={true}
                                                                            />
                                                                        </div>

                                                                        <div className="w-full">


                                                                            <TextFieldFormsy
                                                                                className="w-1/2 pr-8 mt-16"
                                                                                type="text"
                                                                                name="fax"
                                                                                label="Fax"
                                                                                value={fax}
                                                                            // disabled={true}
                                                                            />

                                                                            <TextFieldFormsy
                                                                                className="w-1/2  mt-16"
                                                                                type="text"
                                                                                name="email"
                                                                                label="Email"
                                                                                value={email}
                                                                                validations="isEmail"
                                                                                validationError="This is not a valid email"
                                                                            />
                                                                        </div>

                                                                        <div className="w-full">
                                                                            <FormControlLabel
                                                                                className=" "
                                                                                control={
                                                                                    <Checkbox
                                                                                        checked={this.state.isSuspends}
                                                                                        onChange={this.handleCheckSuspendChanges('isSuspends')}
                                                                                        color="primary"
                                                                                    />
                                                                                }
                                                                                label="Suspend"
                                                                            />
                                                                            <FormControlLabel
                                                                                className=" "
                                                                                control={
                                                                                    <Checkbox
                                                                                        checked={this.state.isActives}
                                                                                        onChange={this.handleCheckActiveChanges('isActives')}
                                                                                        color="primary"
                                                                                    />
                                                                                }
                                                                                label="Active"
                                                                            />
                                                                        </div>

                                                                    </DialogContent>
                                                                    <DialogActions>
                                                                        <Button type="button" onClick={this.handleCloseEdit} variant="raised" size="small" color="primary" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 mr-8">
                                                                            Close
                                                                        </Button>

                                                                        <Button type="submit" variant="raised" size="small" color="secondary" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 mr-8">
                                                                            Update
                                                                        </Button>
                                                                    </DialogActions>
                                                                </Formsy>
                                                            </Dialog>


                                                            {/* /////me */}

                                                            {/* <IconButton
                                                        onClick={(e) => {
                                                            if (row) {

                                                                // updateTradeId = row.original.superTradeId;
                                                                // updateTradeName = row.original.superTradeName;
                                                                // isActive = row.original.isActive;
                                                                this.setState({ delete: true });
                                                                id = row.original.id;
                                                                // alert(id);


                                                            }
                                                        }}

                                                    >
                                                        <Icon className="text-red-light">delete</Icon>
                                                    </IconButton> */}


                                                            {/* /////me */}

                                                            <Dialog
                                                                open={this.state.delete}
                                                                onClose={this.handleClose}
                                                                aria-labelledby="form-dialog-title"
                                                            >
                                                                <DialogTitle id="form-dialog-title">Delete Profesional Qualification</DialogTitle>
                                                                <DialogContent>

                                                                    <div>

                                                                        <Formsy
                                                                            onValidSubmit={this.onDelete}
                                                                            onValid={this.enableButtonDelete}
                                                                            onInvalid={this.disableButtonDelete}
                                                                            ref={(form) => this.form = form}
                                                                            className="flex flex-col justify-center"
                                                                        >
                                                                            <TextFieldFormsy
                                                                                type="hidden"
                                                                                name="id"
                                                                                value={id}
                                                                            />

                                                                            <DialogActions>
                                                                                <Button onClick={this.handleCloseDelete} color="primary">
                                                                                    Cancel
                                                                                </Button>

                                                                                <Button
                                                                                    type="submit"
                                                                                    variant="raised"
                                                                                    color="primary"
                                                                                    className="mx-auto mt-16 pb-15"
                                                                                    aria-label="Edit"
                                                                                // disabled={!canEdit}
                                                                                >
                                                                                    Change
                                                                                </Button>
                                                                            </DialogActions>
                                                                        </Formsy>
                                                                    </div>
                                                                </DialogContent>


                                                            </Dialog>

                                                            {/* ///// */}


                                                        </div>
                                                    )
                                                }

                                            ]}
                                            defaultPageSize={10}
                                            className="-striped -highlight"
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </React.Fragment>
            );
        }
    }

}


export default withStyles(styles, { withTheme: true })(withAlert(Broker));


// WEBPACK FOOTER //
// ./src/main/content/sales/broker/brokerAdd.js